import { IAuthState } from './interface'

export const AuthState: IAuthState = {
  user: undefined,
  fetching: true
}
